import { gql } from "@apollo/client";
const ADD_PRODUCT = gql`
  mutation addProduct($input: UpsertLineCartInput!) {
    addProduct(input: $input) {
      __typename
      ... on LineCart {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const UPDATE_PRODUCT = gql`
  mutation updateQuantityOfProduct($input: UpsertLineCartInput!) {
    updateQuantityOfProduct(input: $input) {
      __typename
      ... on LineCart {
        id
        quantity
        total
        product {
          id
          name
          description
          price
          stock
          shine
          url_image
        }
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const DELETE_PRODUCT = gql`
  mutation deleteProductFromCart($id: Float!) {
    deleteProductFromCart(id: $id) {
      __typename
      ... on LineCart {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { ADD_PRODUCT, UPDATE_PRODUCT, DELETE_PRODUCT };
